import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Base from "../../Config/Base";
import { API_BASE_CRM_URL } from "../../Config/Config";
import { Link } from "react-router-dom";
import { Select, Tabs, Input } from "antd";
import { Footer } from "../footer/footer";
import { NotificationOutlined, TeamOutlined } from "@ant-design/icons";
import LeadNotes from "./LeadNotes";
import LeadProposal from "./LeadProposal";
import Reminders from "../DynamicReminders/Reminders";

const { TextArea } = Input;
export default function ViewLead() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || "profile",
  );
  const [leadsData, setLeadsData] = useState();
  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const handleEditClick = () => {
    if (isEditing) {
      setFormData(leadsData);
    }

    setIsEditing(!isEditing);
  };
  const [formData, setFormData] = useState({});
  const [leadSourceOptions, setLeadSourceOptions] = useState([]);
  const [leadStatusOptions, setLeadStatusOptions] = useState([]);
  console.log(leadStatusOptions, "leadsoptions...........");
  const [staffOptions, setStaffOptions] = useState([]);

  const [leadSourceLoading, setLeadSourceLoading] = useState(false);
  const [leadStatusLoading, setLeadStatusLoading] = useState(false);
  const [staffLoading, setStaffLoading] = useState(false);

  const fetchLeadSources = async () => {
    try {
      setLeadSourceLoading(true);

      const response = await fetch(`${API_BASE_CRM_URL}leads/GetLeadSources`);

      const data = await response.json();

      if (data?.Status) {
        const formattedData = data.ResultData.map((item) => ({
          value: item.SourceId,
          label: item.SourceName,
        }));

        setLeadSourceOptions(formattedData);
      }
    } catch (error) {
      console.error("Error fetching lead sources:", error);
    } finally {
      setLeadSourceLoading(false);
    }
  };

  const fetchLeadStatus = async () => {
    try {
      setLeadStatusLoading(true);

      const response = await fetch(`${API_BASE_CRM_URL}leads/GetLeadStatus`);

      const data = await response.json();

      if (data?.Status) {
        const formattedData = data.ResultData.map((item) => ({
          value: item.id,
          label: item.name,
          color: item.color,
        }));

        setLeadStatusOptions(formattedData);
      }
    } catch (error) {
      console.error("Error fetching lead status:", error);
    } finally {
      setLeadStatusLoading(false);
    }
  };

  const fetchStaffDropdown = async () => {
    try {
      setStaffLoading(true);

      const response = await fetch(`${API_BASE_CRM_URL}staff/GetStaffDropdown`);

      const data = await response.json();

      if (data?.ResultData) {
        const formattedData = data.ResultData.map((item) => ({
          value: item.staffid,
          label: `${item.firstname} ${item.lastname}`,
          email: item.email,
        }));

        setStaffOptions(formattedData);
      }
    } catch (error) {
      console.error("Error fetching staff:", error);
    } finally {
      setStaffLoading(false);
    }
  };

  useEffect(() => {
    if (isEditing) {
      fetchLeadSources();
      fetchLeadStatus();
      fetchStaffDropdown();
    }
  }, [isEditing]);

  useEffect(() => {
    if (leadsData) {
      setFormData({
        id: leadsData.id,
        name: leadsData.name || "",
        company: leadsData.company || "",
        email: leadsData.email || "",
        phonenumber: leadsData.phonenumber || "",
        website: leadsData.website || "",
        address: leadsData.address || "",
        city: leadsData.city || "",
        state: leadsData.state || "",
        zip: leadsData.zip || "",
        status: leadsData.status,
        source: leadsData.source,
        assigned: leadsData.assigned,
        description: leadsData.description || "",
      });
    }
  }, [leadsData]);

  const handleEditToggle = () => {
    if (isEditing) {
      // Reset fields when cancelling
      setFormData({
        id: leadsData.id,
        name: leadsData.name || "",
        company: leadsData.company || "",
        email: leadsData.email || "",
        phonenumber: leadsData.phonenumber || "",
        website: leadsData.website || "",
        address: leadsData.address || "",
        city: leadsData.city || "",
        state: leadsData.state || "",
        zip: leadsData.zip || "",
        status: leadsData.status,
        source: leadsData.source,
        assigned: leadsData.assigned,
        description: leadsData.description || "",
      });
    }

    setIsEditing(!isEditing);
  };
  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    if (id) {
      sessionStorage.setItem("purchaseId", JSON.stringify(id));
    }
  }, []);

  useEffect(() => {
    const fetchContacts = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_CRM_URL}leads/GetLeadById?LeadId=${id}`,
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        console.log(data, "data view lead detailssss");

        // Ensure data is an array
        if (data.Status) {
          setLeadsData(data.ResultData);
        } else {
          setLeadsData();
          console.error("Unexpected response format:", data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchContacts();
  }, [id]);

  const items = [
    {
      key: "profile",
      label: (
        <span className="custom-tab-label">
          <i className="fas fa-user me-1"></i>
          <span>Profile</span>
        </span>
      ),
      children: (
        <>
          {!isEditing ? (
            <div className="container-fluid p-2">
              <div className="card shadow-sm border-0">
                <div className="card-body">
                  {/* Lead Header */}

                  {/* Contact Information */}
                  <div className="mb-3">
                    <div className="d-flex justify-content-between border-bottom pb-1">
                      <h6 className="">
                        <i className="fas fa-address-card me-2 text-primary"></i>
                        Contact Information
                      </h6>
                      <i
                        className="fa-solid fa-edit d-none"
                        onClick={handleEditClick}
                      ></i>
                    </div>
                    <div className="row g-2">
                      <div className="col-6">
                        <i className="fas fa-user text-muted me-2"></i>
                        <b>{leadsData?.name || "N/A"}</b>
                      </div>
                      <div className="col-6">
                        <i className="fa-solid fa-buildings text-muted me-2"></i>
                        <small>{leadsData?.company || "N/A"}</small>
                      </div>
                      <div className="col-12">
                        <i className="fas fa-envelope text-muted me-2"></i>
                        <small className="text-break">
                          {leadsData?.email || "N/A"}
                        </small>
                      </div>

                      <div className="col-6">
                        <i className="fas fa-phone text-muted me-2"></i>
                        <small>{leadsData?.phonenumber || "N/A"}</small>
                      </div>

                      <div className="col-12">
                        <i className="fas fa-globe text-muted me-2"></i>
                        {leadsData?.website ? (
                          <a
                            href={leadsData.website}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="small text-break"
                          >
                            {leadsData.website}
                          </a>
                        ) : (
                          <small>N/A</small>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* Lead Details */}
                  <div className="mb-3">
                    <h6 className="border-bottom pb-1">
                      <i className="fas fa-bullseye me-2 text-success"></i>
                      Lead Details
                    </h6>

                    <div className="row g-2">
                      <div className="col-6">
                        <i className="fas fa-flag text-muted me-2"></i>
                        <small>{leadsData?.StatusName || "N/A"}</small>
                      </div>

                      <div className="col-6">
                        <i className="fas fa-share-alt text-muted me-2"></i>
                        <small>{leadsData?.SourceName || "N/A"}</small>
                      </div>

                      <div className="col-6">
                        <i className="fas fa-user-tie text-muted me-2"></i>
                        <small>{leadsData?.AssignedTo || "N/A"}</small>
                      </div>

                      <div className="col-6">
                        <i className="fas fa-rupee-sign text-muted me-2"></i>
                        <small>
                          ₹{Number(leadsData?.lead_value || 0).toLocaleString()}
                        </small>
                      </div>
                    </div>
                  </div>
                  {/* Address */}
                  <div className="mb-3">
                    <h6 className="border-bottom pb-1">
                      <i className="fas fa-map-marker-alt me-2 text-secondary"></i>
                      Address
                    </h6>

                    <small>
                      <i className="fas fa-home text-muted me-2"></i>
                      {[
                        leadsData?.address,
                        leadsData?.city,
                        leadsData?.state,
                        leadsData?.zip,
                      ]
                        .filter(Boolean)
                        .join(", ") || "N/A"}
                    </small>
                  </div>

                  {/* Description */}
                  <div className="mb-3">
                    <h6 className="border-bottom pb-1">
                      <i className="fas fa-file-alt me-2 text-secondary"></i>
                      Description
                    </h6>

                    <div className="d-flex align-items-start">
                      <i className="fas fa-align-left text-muted me-3 mt-1"></i>
                      <span>{leadsData?.description || "N/A"}</span>
                    </div>
                  </div>

                  {/* Timeline */}
                  <div>
                    <h6 className="border-bottom pb-1">
                      <i className="fas fa-history me-2 text-secondary"></i>
                      Timeline
                    </h6>

                    <div className="row g-2">
                      <div className="col-6">
                        <i className="fas fa-calendar-plus text-muted me-2"></i>
                        <small>
                          {leadsData?.dateadded
                            ? new Date(leadsData.dateadded).toLocaleDateString()
                            : "N/A"}
                        </small>
                      </div>

                      <div className="col-6">
                        <i className="fas fa-user-check text-muted me-2"></i>
                        <small>
                          {leadsData?.dateassigned
                            ? new Date(
                                leadsData.dateassigned,
                              ).toLocaleDateString()
                            : "N/A"}
                        </small>
                      </div>

                      <div className="col-12">
                        <i className="fas fa-phone-volume text-muted me-2"></i>
                        <small>
                          {leadsData?.lastcontact
                            ? new Date(
                                leadsData.lastcontact,
                              ).toLocaleDateString()
                            : "N/A"}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="container-fluid p-2">
              <div className="card shadow-sm border-0">
                <div className="card-body">
                  <h5 className="mb-3">Edit Lead</h5>
                  <div className="row">
                    <div className="mb-3 col-12">
                      <Input
                        size="middle"
                        placeholder="Name"
                        prefix={<i className="fas fa-user text-muted" />}
                        value={formData.name}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            name: e.target.value,
                          })
                        }
                      />
                    </div>

                    <div className="mb-3 col-12">
                      <Input
                        placeholder="Company"
                        prefix={<i className="fas fa-building text-muted" />}
                        value={formData.company}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            company: e.target.value,
                          })
                        }
                      />
                    </div>

                    <div className="mb-3 col-12">
                      <Input
                        placeholder="Email"
                        prefix={<i className="fas fa-envelope text-muted" />}
                        value={formData.email}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            email: e.target.value,
                          })
                        }
                      />
                    </div>

                    <div className="mb-3 col-6">
                      <Input
                        placeholder="Phone"
                        prefix={<i className="fas fa-phone text-muted" />}
                        value={formData.phonenumber}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            phonenumber: e.target.value,
                          })
                        }
                      />
                    </div>

                    <div className="mb-3 col-6">
                      <Select
                        style={{ width: "100%" }}
                        placeholder="Status"
                        value={formData.status}
                        options={leadStatusOptions}
                        loading={leadStatusLoading}
                        suffixIcon={<i className="fas fa-flag" />}
                        onChange={(value) =>
                          setFormData({
                            ...formData,
                            status: value,
                          })
                        }
                      />
                    </div>

                    <div className="mb-3 col-6">
                      <Select
                        style={{ width: "100%" }}
                        placeholder="Source"
                        value={formData.source}
                        options={leadSourceOptions}
                        loading={leadSourceLoading}
                        suffixIcon={<NotificationOutlined />}
                        onChange={(value) =>
                          setFormData({
                            ...formData,
                            source: value,
                          })
                        }
                      />
                    </div>

                    <div className="mb-3 col-6">
                      <Select
                        style={{ width: "100%" }}
                        placeholder="Assigned To"
                        value={formData.assigned}
                        options={staffOptions}
                        loading={staffLoading}
                        suffixIcon={<TeamOutlined />}
                        onChange={(value) =>
                          setFormData({
                            ...formData,
                            assigned: value,
                          })
                        }
                      />
                    </div>

                    <div className="mb-3 col-12">
                      <TextArea
                        rows={4}
                        placeholder="Description"
                        value={formData.description}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            description: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  {/* <div className="d-flex gap-2">
                    <Button type="primary">Save</Button>

                    <Button onClick={handleEditClick}>Cancel</Button>
                  </div> */}
                  {/* <div className="d-flex justify-content-end mt-3">
                    <Button
                      danger
                      icon={<CloseOutlined />}
                      onClick={handleEditClick}
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "10px", // Use 0 for a perfect square
                      }}
                      className="me-2"
                    />
                    <Button
                      type="succsess"
                      icon={<CheckOutlined />}
                      htmlType="submit"
                      style={{
                        width: "40px",
                        height: "40px",
                        color: "green",
                        borderRadius: "10px", // Use 0 for a perfect square
                        borderColor: "#52c41a",
                      }}
                    />
                  </div> */}

                  <div className="d-flex gap-2  justify-content-end">
                    {/* Cancel */}
                    <div
                      onClick={handleEditClick}
                      style={{
                        width: "38px",
                        height: "38px",
                        background: "#fff",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                      }}
                    >
                      <i
                        className="fa-solid fa-xmark"
                        style={{
                          color: "#dc3545",
                          fontSize: "16px",
                        }}
                      />
                    </div>

                    {/* Save */}
                    <div
                      // onClick={handleUpdateNote}
                      style={{
                        width: "38px",
                        height: "38px",
                        background: "#fff",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                      }}
                    >
                      <i
                        className={`fa-solid ${
                          loading ? "fa-spinner fa-spin" : "fa-check"
                        }`}
                        style={{
                          color: "#198754",
                          fontSize: "16px",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      ),
    },
    {
      key: "proposals",
      label: (
        <span className="custom-tab-label">
          <i className="fas fa-file-alt me-1"></i>
          <span>Proposals</span>
        </span>
      ),
      children: <LeadProposal id={id} type="leads" />,
    },
    {
      key: "reminders",
      label: (
        <span className="custom-tab-label">
          <i className="fas fa-bell me-1"></i>
          <span>Follow-Ups</span>
        </span>
      ),
      children: <Reminders customerId={id} relType="Lead" />,
    },
    {
      key: "notes",
      label: (
        <span className="custom-tab-label">
          <i className="fas fa-sticky-note me-1"></i>
          <span>Notes</span>
        </span>
      ),
      children: <LeadNotes id={id} type="leads" />,
    },
  ];

  return (
    <Base>
      <div className="page-heade mb-3">
        <div className="row align-items-center">
          <div className="col-7">
            <div className="page-title">
              <h4>Lead Details</h4>
              {/* <p className="fw-semibold">View details</p> */}
            </div>
          </div>
          <div className="col-5 d-flex justify-content-end">
            <Link
              to={{
                pathname: "/add-customer",
              }}
              state={{ lead: leadsData }}
            >
              <button className="btn btn-success btn-sm">
                <img
                  src="/assets/img/convertUser.svg"
                  alt="Convert"
                  style={{ height: 16 }}
                />
              </button>
            </Link>
            &nbsp; &nbsp;
            <Link to={"/leads"}>
              <button className="btn btn-secondary btn-sm">
                <i className="fa-solid fa-list"></i>
              </button>
            </Link>
          </div>
          <style>
            {`
           
            /* Default tab color */
            .custom-tabs .ant-tabs-tab {
              color: #666;
            }

            /* Active tab text color */
            .custom-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
              color: #FF8D1F !important;
            }

            /* Active tab icon color */
            .custom-tabs .ant-tabs-tab.ant-tabs-tab-active svg {
              color: #FF8D1F !important;
            }

            /* Underline color */
            .custom-tabs .ant-tabs-ink-bar {
              background: #FF8D1F !important;
            }

            /* Optional hover effect */
            .custom-tabs .ant-tabs-tab:hover,
            .custom-tabs .ant-tabs-tab:hover svg {
              color: #FF8D1F;
            }`}
          </style>
          <div className="my-2">
            <Tabs
              activeKey={activeTab}
              onChange={(key) => setActiveTab(key)}
              animated
              size="small"
              items={items}
              className="custom-tabs"
            />
          </div>
        </div>
      </div>

      <Footer />
    </Base>
  );
}
